import { render, staticRenderFns } from "./InfoTag.vue?vue&type=template&id=46cb466a&"
import script from "./InfoTag.vue?vue&type=script&lang=js&"
export * from "./InfoTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports